import axios from 'axios';
import { LOG } from '../helpers';

// request config
const API = process.env.REACT_APP_API;
const API_NOSSA = process.env.REACT_APP_NOSSA_API;

export const SET_USER = 'SET_USER';
export const SET_LOADER = 'SET_LOADER';
export const SET_USER_CPF = 'SET_USER_CPF';
export const SET_ERROR = 'SET_ERROR';

export const setUser = user => dispatch => {
  dispatch({ type: SET_USER, user });
};

export const setLoader = isLoading => dispatch => {
  dispatch({ type: SET_LOADER, isLoading });
};

export const setUserCpf = cpf => dispatch => {
  dispatch({ type: SET_USER_CPF, cpf });
};

export const submitActivation = (payload, onSuccess, onError) => () => {
  const { offer, nossaId } = payload;

  axios
    .post(API.concat('/tasting'), { offer, nossaId })
    .then(() => {
      onSuccess();
    })
    .catch(error => {
      if (error.response) {
        LOG('[ERROR][Actions] submitActivation ', error.response);
        onError(error.response.status);
      }
    });
};

export const getUserData = (userInfo, authentication) => dispatch => {
  const { email } = userInfo;
  axios({
    method: 'get',
    url: API_NOSSA.concat(`/user/EMAIL/${email}`),
    withCredentials: true
  })
    .then(result => {
      console.log(result);
      const userData = result.data[0] || {};
      setUser({ userInfo, userData, authentication })(dispatch);
    })
    .catch(error => {
      const requestError = 'Error while fetching user data';
      LOG('[ERROR][Actions] getUserData ', requestError, error);
      dispatch({ type: SET_ERROR, error: requestError });
    });
};

export const updateUserData = (
  userId,
  user,
  mobilePhone,
  cpf,
  onSuccess,
  onError
) => () => {
  const headers = { authid: user.userInfo.uid };
  const userData = {
    cpf,
    mobilePhone
  };

  axios({
    method: 'post',
    headers,
    url: API_NOSSA.concat(`/person/individual/additional-info`),
    data: userData,
    withCredentials: true
  })
    .then(() => {
      onSuccess();
    })
    .catch(error => {
      if (error.response) {
        const { data, status } = error.response;
        const CPFexists = status === 422;
        LOG('[ERROR][Actions] updateUserData ', data);
        onError(CPFexists);
      } else {
        onError(false);
      }
    });
};
